import React from 'react';
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client';

import Arrivals from './page/Arrivals.jsx';
import Art from './page/Art.jsx';
import Artist from './page/Artist.jsx';
import Artists from './page/Artists.jsx';
import ArtistsCategory from './page/ArtistsCategory.jsx';
import Browse from './page/Browse.jsx';
import Cities from './page/Cities.jsx';
import City from './page/City.jsx';
import { ArtistInvite, Claim } from './page/Claim.jsx';
import Galleries from './page/Galleries.jsx';
import Gallery from './page/Gallery.jsx';
import Index from './page/Index.jsx';
import Invoice from './page/Invoice.jsx';
import InvoiceConfirmation from './page/InvoiceConfirmation.jsx';
import Labels from './page/Labels.jsx';
import List from './page/List.jsx';
import { Onboarding } from './page/Onboarding.jsx';
import PasswordReset from './page/PasswordReset.jsx';
import { Profile, ProfileSection } from './page/Profile.jsx';
import { Search } from './page/Search.jsx';
import Shared from './app-shared.jsx';
import Show from './page/Show.jsx';
import Shows from './page/Shows.jsx';
import Trending from './page/Trending.jsx';
import TwoFactorSetup, { loginUrl } from './twofactor/TwoFactorSetup';
import Unsubscribe from './page/Unsubscribe.jsx';

import Auth from './error/Auth.jsx';
import Internal from './error/Internal.jsx';
import NotFound from './error/NotFound.jsx';

import { postLoginNavigation } from './twofactor/handoff';

globalThis.React = React;
globalThis.ReactDOM = ReactDOM;
globalThis.Shared = Shared;
globalThis.ArtcloudTwoFactor = { loginUrl, postLoginNavigation };

const pages = {
    'arrivals': Arrivals,
    'art': Art,
    'artist': Artist,
    'artistInvite': ArtistInvite,
    'artists': Artists,
    'artistsCategory': ArtistsCategory,
    'auth': Auth,
    'browse': Browse,
    'cities': Cities,
    'city': City,
    'claim': Claim,
    'decor': Browse,
    'furniture': Browse,
    'galleries': Galleries,
    'gallery': Gallery,
    'home': Index,
    'jewelry': Browse,
    'internal': Internal,
    'invoice': Invoice,
    'invoiceConfirmation': InvoiceConfirmation,
    'labels': Labels,
    'lighting': Browse,
    'list': List,
    'notfound': NotFound,
    'onboarding': Onboarding,
    'passwordReset': PasswordReset,
    'profile': Profile,
    'profileCollection': ProfileSection,
    'profileFollowing': ProfileSection,
    'profileLists': ProfileSection,
    'search': Search,
    'show': Show,
    'shows': Shows,
    'trending': Trending,
    'twoFactor': TwoFactorSetup,
    'unsubscribe': Unsubscribe
};

function renderPage(element) {
    if (!Artcloud.url.vendor.baseUrl) {
        // Wait for library init
        setTimeout(function () {
            renderPage(element);
        }, 100);
        return;
    }
    const Page = pages[element.id];
    if (!Page) {
        return;
    }
    const root = createRoot(element);
    root.render(<Page query={element.dataset.query} />);
}

document.querySelectorAll('.page__root').forEach(renderPage);